//import  AuthService  from './AuthService'
import { ITenant } from "../../types/Tenant/ITenant";
import { IHostConfig } from "../../types/Tenant/IHostConfig";
import { Api } from "./BaseApi";

const AccountApi = Api.injectEndpoints({
  endpoints: (build) => ({
    getTenant: build.query<ITenant, string>({
      query: (tenantUrl) => "Account/TenantConfig/?tenantUrl=" + tenantUrl,
      providesTags: ["GetTenant"],
    }),
    getHostConfig: build.query<IHostConfig, string>({
      query: (tenantUid) => `Account/${tenantUid}/SystemConfig`,
      providesTags: ["GetHostConfig"],
    }),
  })
});

export const {
  useGetTenantQuery,
  useGetHostConfigQuery,
} = AccountApi;